function filterByRegion(customers, region) {
  const regionCustomers = {}
  const customerKeys = Object.keys(customers)
  const customerCount = customerKeys.length

  for (let index = 0; index < customerCount; index += 1) {
    const customerKey = customerKeys[index]
    const customer = customers[customerKey]
    const customerRegion = customer.region || 'pnh'

    if (region === customerRegion) regionCustomers[customerKey] = customer
  }

  return regionCustomers
}

export default {
  filterByRegion
}


// WEBPACK FOOTER //
// ./src/utils/customer.js